
export class BaseSharePointGraphGroupModel {
  id: string;
  displayName: string;
  description: string;
  visibility: string;
  securityEnabled: boolean;
  createdDateTime: Date|null;
}
